import React, { useState, useCallback } from 'react'
import Menu from './Menu'
import ButtonWithMenu from '../ButtonWithMenu'

const CentralizeSection = ({ className, active }) => {
  const [open, setOpen] = useState(false)

  const handleCloseMenu = useCallback(() => {
    setOpen(false)
  }, [])
  return (
    <ButtonWithMenu
      css={className}
      open={open}
      isActive={active === 'Conversations'}
      setOpen={setOpen}
      overlay={<Menu onClose={handleCloseMenu} />}
    >
      Centralize
    </ButtonWithMenu>
  )
}

export default CentralizeSection
